import { create } from "zustand";

export type SelectionModel<T extends { id: string }> = {
  selected: T[];
  isSelected: (row: T) => boolean;
  hasSelection: () => boolean;
  toggle: (row: T) => void;
  clear: () => void;
  init: () => void;
};
export const useSelectionModel = create<SelectionModel<{ id: string }>>((set, get) => ({
  init: () => set(() => ({ selected: [] })),
  selected: [],
  hasSelection: () => get().selected.length > 0,
  clear: () => set({ selected: [] }),
  isSelected: (row) => get().selected.findIndex((r) => r.id === row.id) !== -1,
  toggle: (row) =>
    set((state) => {
      const isSelected = state.selected.findIndex((r) => r.id === row.id) !== -1;
      if (isSelected) {
        return { selected: state.selected.filter((r) => r.id !== row.id) };
      }
      return { selected: [...state.selected, row] };
    }),
}));

export const getSelectionModel = () => useSelectionModel.getState();
